/* eslint-disable arrow-body-style */
import { OfflineOrderingState, PostPaidPayload } from '../types';

const addFactorDetails = (state: OfflineOrderingState, value: Partial<PostPaidPayload>): OfflineOrderingState => {
  return {
    ...state,
    ...value,
  };
};

export default addFactorDetails;
